import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { CheckoutElementsProvider } from '@stripe/react-stripe-js/checkout'

import { useIsDarkMode } from '~/hooks/use-is-dark-mode'
import { getStripe } from '~/utils/get-stripe'
import { getStripeElementsAppearance } from '~/utils/get-stripe-elements-appearance'
import { langWithoutRegion } from '~/utils/lang-without-region'

type StripeCheckoutElementsProps = PropsWithChildren<{
  clientSecret: string
}>

export const StripeCheckoutElements = ({ clientSecret, children }: StripeCheckoutElementsProps) => {
  const { i18n } = useTranslation()
  const isDarkMode = useIsDarkMode()
  const language = langWithoutRegion(i18n.language)

  return (
    <CheckoutElementsProvider
      key={language}
      options={{
        clientSecret,
        elementsOptions: {
          appearance: getStripeElementsAppearance(isDarkMode),
        },
      }}
      stripe={getStripe()}
    >
      {children}
    </CheckoutElementsProvider>
  )
}
